import { WorkspaceWeightIndicator } from "@hoylu/client-common";
import React, { useMemo } from "react";
import Styles from "./WorkspaceWeight.module.css";

/** Calculate workspace indicator percentage based on logarithmic formula log2(weight/40) + 1 */
export function calculateWorkspaceWeightPercent(weight: number): number {
  // forumla as specified in #13421
  // Note: is clamped to 100 since WorkspaceweightIndicator does not support values > 100
  if (weight > 0) {
    return Math.min((Math.log2(weight / 40) + 1) / 12, 1) * 100;
  }
  return 0;
}

export const WorkspaceWeight = ({
  workspaceWeight,
  inWarningMode,
}: {
  workspaceWeight: number | undefined | null;
  inWarningMode: boolean;
}): React.JSX.Element => {
  const percent = useMemo(
    () =>
      workspaceWeight ? calculateWorkspaceWeightPercent(workspaceWeight) : 0,
    [workspaceWeight],
  );

  return (
    <div className={Styles.workspaceWeight}>
      <WorkspaceWeightIndicator
        backgroundColor="var(--global--dark-text-and-icon--Color)"
        foregroundColor={
          inWarningMode ? "var(--global--error--Color)" : undefined
        }
        percent={percent}
      />
    </div>
  );
};
